import { Manifest } from '@anm/hosting-player';

const isVideoBlocked = (manifest?: Manifest) => !!(manifest?.status && manifest.meta && !manifest.main);

export default isVideoBlocked;
